import { inputClass } from '../AuthCard.tsx';
import { Bullets, ListTextarea } from './listUtils.tsx';
import type { EditProps, ViewProps } from './types.ts';

export function PhaseListView({ content }: ViewProps<'phase_list'>) {
  if (content.phases.length === 0) return null;
  return (
    <ol className="space-y-3 border-l-2 border-gray-200 pl-4">
      {content.phases.map((phase, i) => (
        <li key={i} className="break-inside-avoid">
          <p className="text-sm">
            <span className="font-semibold text-gray-800">{phase.name}</span>
            {phase.timeframe && <span className="ml-2 text-gray-400">{phase.timeframe}</span>}
          </p>
          <div className="mt-1">
            <Bullets items={phase.items} />
          </div>
        </li>
      ))}
    </ol>
  );
}

export function PhaseListEdit({ content, onChange }: EditProps<'phase_list'>) {
  const setPhase = (i: number, patch: Partial<(typeof content.phases)[number]>) =>
    onChange({
      ...content,
      phases: content.phases.map((phase, j) => (j === i ? { ...phase, ...patch } : phase)),
    });
  return (
    <div className="space-y-4">
      {content.phases.map((phase, i) => (
        <div key={i} className="rounded-lg border border-gray-200 p-3">
          <div className="mb-2 flex gap-2">
            <input
              className={inputClass}
              placeholder="Phase name"
              value={phase.name}
              onChange={(e) => setPhase(i, { name: e.target.value })}
            />
            <input
              className={inputClass}
              placeholder="Timeframe (e.g. Q3 2026)"
              value={phase.timeframe}
              onChange={(e) => setPhase(i, { timeframe: e.target.value })}
            />
            <button
              type="button"
              className="text-sm whitespace-nowrap text-red-500 hover:underline"
              onClick={() =>
                onChange({ ...content, phases: content.phases.filter((_, j) => j !== i) })
              }
            >
              Remove
            </button>
          </div>
          <ListTextarea
            label="Milestones / activities"
            values={phase.items}
            onChange={(items) => setPhase(i, { items })}
            rows={3}
          />
        </div>
      ))}
      <button
        type="button"
        className="text-sm text-blue-600 hover:underline"
        onClick={() =>
          onChange({
            ...content,
            phases: [...content.phases, { name: '', timeframe: '', items: [] }],
          })
        }
      >
        Add phase
      </button>
    </div>
  );
}
